import { getState } from "../../../helpers";
import { selectToken } from "../selectors";

export const CHERY_TOKEN = "hyt67gfr43edfr65dd";

export const CHERY_ONLINE_TOKEN = "cheryonline";

export const CHERY_CALC_TOKEN = "cherycalc";

export const CHERY_FULL_TOKEN = "cheryfull";

export const CHERYNEW = "cherynew";

export const isChery = (token) => {
  token = token && token.length ? token : selectToken(getState());
  return token === CHERY_TOKEN;
};

export const isCheryOnline = () => {
  const token = selectToken(getState());
  return token === CHERY_ONLINE_TOKEN;
};

export const isCheryCalc = () => {
  const token = selectToken(getState());
  return token === CHERY_CALC_TOKEN;
};

export const isCheryFull = () => {
  const token = selectToken(getState());
  return token === CHERY_FULL_TOKEN;
};

export const isAnyChery = (token) => {
  token = token && token.length ? token : selectToken(getState());
  return (
    isChery(token) ||
    isCheryOnline(token) ||
    isCheryFull(token) ||
    isCheryCalc(token)
  );
};

